import { useEffect, useRef } from 'react';
import { pusher } from '../../pusher';

/**
 * Runs `onChanged` whenever the organisation's object library changes
 * (publish, archive, configuration) — the server's `object-library-updated`
 * on `organisation-{id}`.
 *
 * Only unbinds on cleanup: the channel is shared with other organisation
 * listeners (useOrganisationProjectEvents), which must keep receiving.
 */
export const useObjectLibraryEvents = ({ organisationId, onChanged }: { organisationId: string | null | undefined; onChanged: () => void }) => {
  const callbackRef = useRef(onChanged);
  useEffect(() => {
    callbackRef.current = onChanged;
  }, [onChanged]);

  useEffect(() => {
    if (!organisationId) return;
    const channel = pusher.subscribe(`organisation-${organisationId}`);
    const handler = () => callbackRef.current();
    channel.bind('object-library-updated', handler);
    return () => {
      channel.unbind('object-library-updated', handler);
    };
  }, [organisationId]);
};
